import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Settings from "../instructor/pages/Settings";
import DocTemplate from "./pages/DocTemplate";
import GroupDetails from "./pages/GroupDetails";
import GroupHome from "./pages/GroupHome";
import HomePage from "./pages/HomePage";
import SwitchSchool from "./pages/SwitchSchool";
// import DocTemplate from "./pages/DocTemplate";

const url = "/dashboard";

const SuperAdminRoutes = () => {
  return (
    <Routes>
      <Route path="super-admin/school" element={<HomePage />} />
      <Route path="super-admin/school/:id" element={<SwitchSchool />} />
      <Route path="super-admin/school/doc/:id" element={<DocTemplate />} />
      <Route path="super-admin/group" element={<GroupHome />} />
      <Route path="super-admin/group/:id" element={<GroupDetails />} />
      <Route path="super-admin/setting/" element={<Settings />} />
      {/* The sidebar links to /settings; keep both so that link isn't a 404. */}
      <Route path="super-admin/settings" element={<Settings />} />
      <Route index element={<Navigate to={`${url}/super-admin/school`} replace />} />
    </Routes>
  );
};

export default SuperAdminRoutes;
